export default "__VITE_ASSET__db8b45c5__"